const FINISHED = new Set(['delivered', 'close_out', 'ready_to_invoice']);
const TROUBLED = new Set(['pre_trip_failed', 'exception', 'aborted']);

export type TripStatusTone = 'neutral' | 'active' | 'done' | 'trouble';

/** "in_transit" → "In transit": the trip's state in the words the office uses. */
export function tripStatusLabel(status: string): string {
  const words = status.replaceAll('_', ' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
}

export function tripStatusTone(status: string): TripStatusTone {
  if (TROUBLED.has(status)) return 'trouble';
  if (FINISHED.has(status)) return 'done';
  if (status === 'pending' || status === 'assigned') return 'neutral';
  return 'active';
}
